module.exports = __webpack_public_path__ + "img/10.97a14530.jpg";